import React, { useState, useEffect } from "react";
import { Modal, Form, Input, message, Spin } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import InputMask from "react-input-mask";
import { enrollmentPatient, getNeighborhoods } from "../../services/patient";
import Select from "react-select";

const RegisterPatient = ({
  affiliateData,
  options,
  open,
  onClose,
  OnCompleteModal,
  mode,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(open);
  const [affiliateForm] = Form.useForm();
  const [affiliate, setAffiliate] = useState(affiliateData);
  const [originalManagers, setOriginalManagers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const defaultValue = null;

  const [filters, setFilters] = useState({
    pathologies: [],
    managers: [],
    genders: [],
  });

  const emailHandler = (event) => {
    setAffiliate({
      ...affiliate,
      email: event.target.value,
    });
  };
  const phoneHandler = (event) => {
    //Clean event.target.value from the regex
    let phoneValue = event.target.value.replace(/\D/g, '');

    setAffiliate({
      ...affiliate,
      telephone: phoneValue,
    });
  };
  const setGender = (event) => {
    setAffiliate({
      ...affiliate,
      gender: event,
      genderCd: event.value,
    });
  };
  const addressHandler = (event) => {
    setAffiliate({
      ...affiliate,
      address: event.target.value,
    });
  };
  const setModalPatholyHandler = (event) => {
    // eslint-disable-next-line no-debugger
    setAffiliate({
      ...affiliate,
      pathology: event,
      pathologyId: event.value,
    });
  };

  const setManagerHandler = (event) => {
    setAffiliate({
      ...affiliate,
      manager: event,
      managerId: event.value,
    });
  };
  const setNeighboordHandler = (event) => {
    setAffiliate({
      ...affiliate,
      neighboordhood: event,
      DemograficCd: event.value,
    });
  };
  //When the user click on Ok button then close the modal and reset the form

  const OnComplete = () => {
    //Reset the form
    affiliateForm.resetFields();
    emptyAffiliate();
    OnCompleteModal();
  };

  const onCloseModal = () => {
    //Reset the form
    affiliateForm.resetFields();
    emptyAffiliate();
    onClose();
  };

  const emptyAffiliate = () => {
    //Empty values for the affiliate
    setAffiliate({
      name: "",
      dateOfBirth: "",
      age: "",
      email: "",
      telephone: "",
      address: "",
      pathology: defaultValue,
      pathologyId: "",
      manager: defaultValue,
      managerId: "",
      currentPathology: "",
      pss: defaultValue,
      pssId: "",
      municipality: defaultValue,
      municipalityId: "",
      neighboordhood: defaultValue,
      DemograficCd: undefined,
    });

    //Empty values for the filters for neighboords and managers
    setFilters({
      ...filters,
      managers: [],
      neighboordhoods: [],
    });
  };
  const setPSSHandler = (event) => {
    //Filter the manager based in pss selected
    let managers = originalManagers.filter((y) => y.pss == event.value);
    //Set the managers to the state
    setFilters({
      ...filters,
      managers: managers,
    });

    setAffiliate({
      ...affiliate,
      pss: event,
      pssId: event.value,
      manager: defaultValue,
      managerId: "",
    });
  };
  const setMunicipalityHandlerAsync = (event) => {
    //Clean the affiliate  data of neighboord first
    setAffiliate({
      ...affiliate,
      neighboordhood: defaultValue,
      DemograficCd: "",
      municipality: event,
      municipalityId: event.value,
    });
    getNeighborhoods(event.value).then((data) => {
      const neighboordhoods = data.map((item) => ({
        value: item.key,
        label: item.value,
      }));
      //Set the neighboords to the state
      setFilters({
        ...filters,
        neighboordhoods: neighboordhoods,
      });
    });
  };

  const enrollmentPatientClick = async () => {
    affiliateForm
      .validateFields()
      .then((values) => {
        if (
          values != undefined &&
          values.errorFields != undefined &&
          values.errorFields.length > 0
        ) {
          message.error("Los campos marcados son requeridos");
          return;
        }

        //Asking to the user si esta seguro que desea enrollar el paciente using ant design modal
        //If the user click on Ok button then call the API
        //If the user click on Cancel button then close the modal
        const { confirm } = Modal;
        confirm({
          title:
            "¿Está seguro que desea " +
            (mode != undefined ? "editar" : "registrar") +
            " el paciente?",
          icon: <ExclamationCircleFilled />,
          content:
            "El paciente será " +
            (mode != undefined ? "editado" : "registrado") +
            " en el sistema",
          okText: "Si",
          cancelText: "No",
          onOk() {
            //Call API
            return new Promise((resolve, reject) => {
              enrollmentPatient({
                ...affiliate,
                modo: mode == undefined ? 0 : mode,
              })
                .then(() => {
                  OnComplete();
                  message.success(
                    "El paciente ha sido " +
                    (mode != undefined ? "editado" : "registrado") +
                    " exitosamente!"
                  );
                  resolve();
                })
                .catch((error) => {
                  console.log(error);
                  reject();
                });
            }).catch(() => console.log("Oops errors!"));
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
        if (
          errorInfo.errorFields != undefined &&
          errorInfo.errorFields.length > 0
        ) {
          message.error("Los campos marcados son requeridos");
          return;
        }
      });
  };
  const validatePhoneNumber = (rule, value, callback) => {
    const phoneNumberRegex = /\D/g;
    value = value.replace(phoneNumberRegex, "");
    //validate the phone number don't have any letter and the length is 10
    const hasLetter = phoneNumberRegex.test(value);
    if (value != undefined && (hasLetter || value.length != 10)) {
      callback("El número de teléfono no es válido");
    } else {
      callback(); // No error
    }
  };

  //Set the affiliate data to the state when the prop open change
  useEffect(() => {
    setIsLoading(true);
    setAffiliate(affiliateData);

    //Set default values for the form
    let pathology;
    let manager = {};
    let municipality = {};
    let pss = {};
    let neighboordhood;
    let gender;
    if (options.pathologies != null && options.pathologies.length > 0) {
      //Set the default value for the pathology
      pathology = options.pathologies.find(
        (y) => y.value == affiliateData.pathologyId
      );
    }

    if (options.municipalities != null && options.municipalities.length > 0) {
      //Set the default value for the municipality
      municipality = options.municipalities.find(
        (y) => y.value == affiliateData.municipalityId
      );
    }
    if (options.neighboordhoods != null && options.neighboordhoods.length > 0) {
      //Set the default value for the neighboordhood
      neighboordhood = options.neighboordhoods.find(
        (y) => y.value == affiliateData.neighborhoodId
      );
    }

    //When the pss is not retrive from Api but the manager is retrive from Api
    if (affiliateData.managerId != null && affiliateData.pss == undefined) {
      //Filter the managers based in the manager selected and pss 
      manager = options.managers.find(
        (y) => y.value == affiliateData.managerId
      );
      pss = options.pss.find((y) => y.value == manager.pss);
    } else if (options.pss != null && options.pss.length > 0 && affiliateData.pss != undefined) {
      //Set the default value for the pss
      pss = options.pss.find((y) => y.value == affiliateData.pss);
      manager = options.managers.find(
        (y) => y.value == affiliateData.managerId
      );
    }

    if (options.genders != null && options.genders.length > 0) {
      gender = options.genders.find((y) => y.value == affiliateData.gender);
    }

    setAffiliate({
      ...affiliateData,
      telephone:
        affiliateData.telephone == "nan" ? "" : affiliateData.telephone,
      pathology: pathology ?? defaultValue,
      pathologyId: pathology?.value,
      manager: manager ?? defaultValue,
      managerId: manager?.value,

      //Address information to Dto.
      address: affiliateData?.address,
      neighboordhood: neighboordhood ?? defaultValue,
      demograficCd: neighboordhood?.value,
      municipality: municipality ?? defaultValue,
      municipalityId: municipality?.value,
      pss: pss ?? defaultValue,
      pssId: pss?.value,
      gender: gender ?? defaultValue,
      genderCd: gender?.value,
    });
    setIsLoading(false);
  }, [affiliateData]);

  useEffect(() => {
    setIsModalOpen(open);
  }, [open]);

  //Load pathologies and managers when the component is mounted
  useEffect(() => {
    setIsLoading(true);
    let managers = filters.managers;
    let pss = affiliateData.pss ?? affiliate.pssId;
    //Get all the managers based in the pss selected
    if (pss == undefined || pss == "") {
      //Looking the pss from the manager
      let manager = affiliateData.managerId;
      if (manager != undefined) {
        let managerData = options.managers.find((y) => y.value == manager);
        if (managerData != undefined) {
          pss = managerData.pss;
        }
      }
    }

    //Filter the managers based in the manager selected and pss
    if (pss != undefined && pss != "" && options.managers != undefined) {
      managers = options.managers.filter((y) => y.pss == pss);
    }

    setFilters({
      ...filters,
      pathologies: options.pathologies,
      managers: managers,
      pss: options.pss,
      municipalities: options.municipalities,
      neighboordhoods: options.neighboordhoods,
      genders: options.genders
    });

    setOriginalManagers(options.managers);
    setIsLoading(false);
  }, [options]);

  let formPatient = (

    <Form
      form={affiliateForm}
      id="formRegister"
      fields={[
        {
          name: ["email"],
          value: affiliate.email,
          initialValue: affiliate.email,
        },
        {
          name: ["telephone"],
          value: affiliate.telephone,
          initialValue: affiliate.telephone,
        },
        {
          name: ["gender"],
          value: affiliate.gender,
          initialValue: affiliate.gender,
        },
        {
          name: ["address"],
          value: affiliate.address,
          initialValue: affiliate.address,
        },
        {
          name: ["pathology"],
          value: affiliate.pathology,
          initialValue: affiliate.pathology,
        },
        {
          name: ["neighboordhood"],
          value: affiliate.neighboordhood,
        },
        {
          name: ["manager"],
          value: affiliate.manager,
          initialValue: affiliate.manager,
        },
      ]}
    >
      <div className="row">
        <div className="col-7">
          <Form.Item
            name="email"
            rules={[
              {
                required: false,
                message: "El correo electronico no válido",
                type: "email",
              },
            ]}
          >
            <div className="form-group">
              <label>Email</label>
              <input
                type="text"
                className="form-control"
                value={affiliate.email}
                onChange={emailHandler}
              />
            </div>
          </Form.Item>
        </div>
        <div className="col-5">
          <div className="form-group">
            <label>Teléfono</label>
            {/* Form.Item rule is validate against a regex pattern for phone number */}
            <Form.Item
              name="telephone"
              rules={[
                {
                  required: true,
                  message: "Es requerido",
                },
                { validator: validatePhoneNumber },
              ]}
            >
              <InputMask
                mask="(999) 999-9999"
                value={affiliate.telephone}
                onChange={phoneHandler}
              >
                {(inputProps) => (
                  <Input
                    {...inputProps}
                    type="tel"
                    className="form-control"
                    value={inputProps.value}
                  />
                )}
              </InputMask>
            </Form.Item>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-4">
          <div className="form-group">
            <label>Género</label>
            {/* Form.Item rule is validate against a regex pattern for phone number */}
            <Form.Item
              name="gender"
              rules={[
                {
                  required: true,
                  message: "Es requerido",
                }
              ]}
            >
              <Select
                options={filters.genders}
                menuPortalTarget={document.body}
                onChange={setGender}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                defaultValue={affiliate.gender?.value}
                value={affiliate.gender}
              />
            </Form.Item>
          </div>
        </div>
        <div className="col-8">
          <div className="form-group">
            <label>Patalogia</label>
            <Form.Item rules={[{ required: true, message: "Es requerido" }]}>
              <Select
                options={filters.pathologies}
                menuPortalTarget={document.body}
                onChange={setModalPatholyHandler}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                defaultValue={affiliate.pathology?.value}
                value={affiliate.pathology}
              />
            </Form.Item>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label>PSS</label>
            <br />
            {/* {(affiliate.manager != null && affiliate.manager.pss != undefined ? affiliate.manager.pss : "-")} */}
            <Select
              id="ddlPss"
              options={filters.pss}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              onChange={setPSSHandler}
              defaultValue={affiliate.pss?.value}
              value={affiliate.pss}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label>Gestor</label>
            <Form.Item
              name="manager"
              rules={[{ required: true, message: "Es requerido" }]}
            >
              <Select
                id="registerPatientManager"
                options={filters.managers}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                onChange={setManagerHandler}
                defaultValue={affiliate.manager?.value}
                value={affiliate.manager}
              />
            </Form.Item>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <label>Municipio</label>
            <Select
              id="municipiality"
              options={filters.municipalities}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              onChange={setMunicipalityHandlerAsync}
              defaultValue={affiliate.municipality?.value}
              value={affiliate.municipality}
            />
          </div>
        </div>

        <div className="col-6">
          <div className="form-group">
            <label>Sector</label>
            <Form.Item
              name="neighboordhood"
              rules={[{ required: true, message: "Es requerido" }]}
            >
              <Select
                id="neighboordhood"
                options={filters.neighboordhoods}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                onChange={setNeighboordHandler}
                defaultValue={affiliate.neighboordhood?.value}
                value={affiliate.neighboordhood}
              />
            </Form.Item>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label>Dirección</label>
            <Form.Item
              name={"address"}
              rules={[{ required: true, message: "Es requerido" }]}
            >
              <input
                type="textarea"
                className="form-control"
                value={affiliate.address}
                onChange={addressHandler}
              />
            </Form.Item>
          </div>
        </div>
      </div>
    </Form>

  );
  return (
    <Modal
      title={(mode == undefined ? "Registrar" : "Editar") + " Afiliado"}
      open={isModalOpen}
      onCancel={onCloseModal}
      onOk={enrollmentPatientClick}
    >
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label>Nombre:</label>
            <b className="mx-1">{affiliate.name}</b>
            <br />
            <label>Fecha Nacimiento:</label>
            <b className="mx-1">{affiliate.dateOfBirth}</b>
            <br />
            <label>Edad:</label>
            <b className="mx-1">{affiliate.age}</b>
            <br />
            <label>Patología Actual:</label>
            <br />
            <span className="custom-badge status-green">
              {affiliate.currentPathology}
            </span>
          </div>
        </div>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spin size="large" />
        </div>
      ) : formPatient}
    </Modal>
  );
};

export default RegisterPatient;
